export const ANALYTICS_DESCRIPTION = {
    STOW_SUMMARY_METRIC: "STOW_SUMMARY_METRIC",
    SETTINGS_PAGE_CONSENT_UPDATE: "SETTINGS_PAGE_CONSENT_UPDATE",
    SUMMARY_CONSENT_RESPONSE: "SUMMARY_CONSENT_RESPONSE",
    MY_INSIGHTS_SETTINGS_PAGE: "MY_INSIGHTS_SETTINGS_PAGE",
    MOOD_SURVEY_RESPONSE: "MOOD_SURVEY_RESPONSE"
};
